import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    service: {
      id: null,
      selectedSongs: [],
      link: {
        short: null,
        long: null
      },
      name: null,
      baseName: null,
      fileName: '',
      filePath: '',
      serviceDate: {
        date: null,
        dayPart: 'ochtend',
        dayName: null,
        dayFull: ''
      }
    },
    selectDateStep: {
      dateReady: false,
      day: {
        currentDay: Number,
        selectedDay: Number
      },
      month: {
        currentMonth: Number,
        amountMonths: 12,
        amountMonthDays: Number,
        selectedMonth: 12
      },
      year: {
        currentYear: Number,
        selectedYear: Number,
        amountYears: []
      }
    },
    calculateCurrentDays (month, year) {
      this.selectDateStep.month.amountMonthDays = new Date(year, month, 0).getDate()
    },
    calculateYears (year) {
      let beforeYear = year - 1
      let currentYear = year
      let afterYear = year + 1
      this.selectDateStep.year.amountYears.push(beforeYear, currentYear, afterYear)
    }
  },
  mutations: {
    setDefaultDates (state, payload) {
      state.selectDateStep.day.currentDay = payload.currentStateDay
      state.selectDateStep.month.currentMonth = payload.currentStateMonth
      state.selectDateStep.year.currentYear = payload.currentStateYear
      state.selectDateStep.day.selectedDay = payload.currentStateDay
      state.selectDateStep.month.selectedMonth = payload.currentStateMonth
      state.selectDateStep.year.selectedYear = payload.currentStateYear
    },
    selectDay (state, payload) {
      state.selectDateStep.day.selectedDay = payload.selectedDate
    },
    selectMonth (state, payload) {
      state.selectDateStep.month.selectedMonth = payload.selectedDate
    },
    selectYear (state, payload) {
      state.selectDateStep.year.selectedYear = payload.selectedDate
    },
    selectDayPart (state, payload) {
      state.service.serviceDate.dayPart = payload.selectedPart
    },
    selectStoreSong (state, payload) {
      state.service.selectedSongs.push(payload.song)
    },
    deselectStoreSong (state, payload) {
      state.service.selectedSongs = state.service.selectedSongs.filter(function (song) {
        return song.name !== payload.song.name
      })
    },
    createService (state, payload) {
      state.service.serviceDate.dayName = payload.dayStateName
      state.service.baseName = payload.serviceBaseName
      state.service.id = payload.id
      state.service.serviceDate.date = payload.serviceStoreDate
      state.service.name = payload.serviceStateName
      state.service.fileName = payload.fileStateName
      state.service.filePath = payload.fileStatePath
      state.service.link.long = payload.link.long
      state.service.link.short = payload.link.short
      state.service.serviceDate.dayFull = payload.fullStateDate
    }
  }
})
